
import { useContext, useLayoutEffect, useState } from 'react'
import { AppContext } from '../../../contextApi/ContextApi';

export default function CurrentLogo({website, logo}) {
    const {fetchImage} = useContext(AppContext);
    const [imgUrl, setImgUrl] = useState();
    useLayoutEffect(()=>{
        fetchImage(website, logo, setImgUrl);
    },[logo])
  return (
    <div className='currentLogo'>
        <h2>לוגו נוכחי</h2>
        <img src={imgUrl} style={{width:"250px", height:"250px", borderRadius:"50%", margin:"30px auto"}} alt="current_logo" />
    </div>
  )
}
